export default function({ type, not, all }) {
    return (patient, args, filter, provider) => {

        if (typeof patient.count_event !== 'object' ||
            typeof patient.first_event !== 'object' ||
            typeof patient.last_event !== 'object' ||
            typeof patient.schedule_event !== 'object')
            return false

		const scheduleCache = (provider && patient.provider_schedule_event && patient.provider_schedule_event[provider]) ?
			patient.provider_schedule_event[provider] : patient.schedule_event

        // If the last event is before the start time of the filter
        if (filter.start) {
            if (type === 'event') {
                if (args.every((arg) => {
                    let scheduleEvent = scheduleCache[arg]
                    return scheduleEvent == null ||
                           Object.keys(scheduleEvent).map((t) => parseInt(t))
                                 .every((time) => (time < filter.start || (filter.end != null && time > filter.end)))
                })) return false
            }
            // else if (type === 'symptom' || type === 'vital') {
            //     let end = Object.keys(patient.last_event)
            //
            //     // If every argument either was not recorded or was before the start time
            //     if (args.every((arg) => {
            //         let lastEvent = patient.last_event[type + ':' + arg]
            //         return lastEvent == null || lastEvent < filter.startEvent
            //     })) return false
            // }
        }
        if (filter.end) {
            if (type === 'event') {
                if (args.every((arg) => {
                    let scheduleEvent = scheduleCache[arg]
                    return scheduleEvent == null ||
                           Object.keys(scheduleEvent).map((t) => parseInt(t))
                                 .every((time) => (time > filter.end || (filter.start != null && time < filter.start)))
                })) return false
            }
            else {
                // TODO: compare startEvent
                // let end = Object.keys(patient.first_event)
                //
                // // If every argument either was not recorded or was after the end time
                // if (args.every((arg) => {
                //     let firstEvent = patient.first_event[type + ':' + arg]
                //     return firstEvent == null || firstEvent > filter.startEvent
                // })) return false
            }
        }
        // // If the last event is before the start time of the filter
        // if (filter.end) {
        //     let end = Object.keys(patient.last_event)
        //     if (args.every((arg) => start.some((key) => key.startsWith(type + ':' + arg) && patient.first_event[key] != null && patient.first_event[key] > filter.end)))
        //         return false
        // }

		if (type === 'event') {
			if (provider && patient.provider_schedule_event) {
                const cache = patient.provider_schedule_event[provider]
                if (cache)
                    return args.some((arg) => cache[arg] != null)
                return false
			 }
			 else if (patient.schedule_event) {
				 return args.some((arg) => patient.schedule_event[arg] != null)
			 }
			 return false
		}

        let keys = Object.keys(patient.count_event).filter((k) => k.startsWith(type))
        // There is some event ID where a particular event count is greater than 0
        let result = args.some((arg) => keys.some((key) => key.startsWith(type + ':' + arg)))

        return not ? !result : result
    }
}
